/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
	selector: '[uppercaseInput]',
	standalone: false,
})
export class UppercaseInputDirective {
	constructor(private el: ElementRef, private control: NgControl) {}

	@HostListener('input', ['$event'])
	onInput(event: Event) {
		const input = this.el.nativeElement;
		const upper = input.value.toUpperCase();
		if (input.value !== upper) {
			input.value = upper;
			// Update the form control value if used with reactive forms
			if (this.control && this.control.control) {
				this.control.control.setValue(upper, { emitEvent: false });
			}
		}
	}
}
